import { redirect, LoaderFunctionArgs } from 'react-router-dom';

import { authValidation } from '@/utils/auth';

import { ROUTES } from './routes';

export function authRouteLoader() {
  if (authValidation()) {
    return redirect('/');
  }
  return null;
}

export function redirectHomeLoader() {
  return redirect('/');
}

export function protectedLoader({ request }: LoaderFunctionArgs) {
  // If the user is not logged in and tries to access `/protected`, we redirect
  // them to `/login` with a `from` parameter that allows login to redirect back
  // to this page upon successful authentication
  const isAuth = authValidation();
  if (!isAuth) {
    const url = new URL(request.url);
    const params = new URLSearchParams();
    if (url.pathname !== ROUTES.LOGOUT) params.set('from', url.pathname);
    return redirect(ROUTES.LOGIN + '?' + params.toString());
  }
  return null;
}
